import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, mergeProps as _mergeProps } from "vue"
import _imports_0 from '@/assets/images/chevron-left.png'
import _imports_1 from '@/assets/images/chevron-right.png'


const _hoisted_1 = { class: "loan-options-navigation-container loan-options-buttons-group" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "loan-options-container-wrapper" }
const _hoisted_4 = { class: "loan-options-container" }
const _hoisted_5 = ["data-count"]
const _hoisted_6 = ["position"]
const _hoisted_7 = {
  key: 0,
  class: "loan-options-navigation-container pagination"
}
const _hoisted_8 = { class: "slider" }
const _hoisted_9 = {
  key: 0,
  class: "loan-options-error-wrapper"
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = ["data-count"]

import {
  ref,
  reactive,
  computed,
  onMounted,
  onBeforeUnmount,
  watch,
} from "vue";
import { useStore } from "vuex";
import PelLoanOptionsHeader from "@/components/pel-loan-configuration/PelLoanOptionsHeader.vue";
import PelLoanOption from "@/components/pel-loan-configuration/PelLoanOption.vue";
import NextButton from "@/components/shared/NextButton.vue";
import useHtmlUtilities from "@/use/htmlUtilities";
import { RateTypeIds } from "@/config/constants";
import CircleLoader from "@/components/shared/CircleLoader.vue";
import useApplicationInfo from "@/composables/application-info/useApplicationInfo";

interface Pagination {
  currentPage: number;
  perPage: number;
  totalPages: number;
  pages: number[];
  currentRepaymentTerm: number;
  variableRateCurrentPage: number;
  fixedRateCurrentPage: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PelLoanOptions',
  props: {
  loading: {
    type: Boolean,
    default: false,
  },
  isCurrent: {
    type: Boolean,
    required: false,
  },
  showPreviousButton: {
    type: Boolean,
    default: true,
  },
},
  emits: ["complete", "previous", "close"],
  setup(__props, { emit: __emit }) {

const store = useStore();

const { isColorDark } = useHtmlUtilities();

const props = __props;

const emit = __emit;

const gettingData = ref<boolean>(true);
const savingChanges = ref<boolean>(false);
const carouselData = ref([] as any[]);
const windowWidth = ref<number>(0);

const { editingFromConfirmYourLoanDetails } = useApplicationInfo();

const isMobile = computed(() => windowWidth.value <= 576);

const isTablet = computed(() => windowWidth.value <= 992 && windowWidth.value > 576);

const dark = computed(() => isColorDark(store.state.lenderData.primaryColor));

const loanConfigurationModule = computed(() => store.state.loanConfigurationModule);

const error = computed<boolean>(() => store.state.loanConfigurationModule.error);

const errorMessages = computed<Array<string>>(
  () => store.state.loanConfigurationModule.errorMessages,
);

const pelLoanOptionsState = computed(
  () => store.state.loanConfigurationModule.loanOptionsConfiguration,
);

const rateTypeSections = computed(
  () => store.state.loanConfigurationModule.loanOptionsConfiguration.rateTypeSections,
);

const rateTypeActive = ref<number>(0);

const availableTerms = computed(() => {
  if (currentlyViewing.value?.length > 0) {
    return (
      currentlyViewing.value
        .map((rp: any) => rp.repaymentTerm)
        .sort((a: number, b: number) => a - b) || []
    );
  }
  return [];
});

const saveChangesDisabled = computed<boolean>(
  () => !selectedRatePlan.value?.id && !selectedRepaymentOption.value?.repaymentTypeId,
);

const fixedRatePlans = computed(() => store.state.loanConfigurationModule.fixedRatePlans);

const variableRatePlans = computed(() => store.state.loanConfigurationModule.variableRatePlans);

const previouslySelectedRatePlan = computed(
  () => store.state.loanConfigurationModule.loanOptionsConfiguration.selectedRatePlan,
);

const selectedRatePlan = computed(() => store.state.loanConfigurationModule.selectedRatePlan);

const selectedRepaymentOption = computed(
  () => store.state.loanConfigurationModule.selectedRepaymentOption,
);

const previouslySelectedRepaymentOption = computed(
  () => store.state.loanConfigurationModule.loanOptionsConfiguration.selectedRepaymentOption,
);

const validRatePlans = computed<boolean>(() => carouselData.value && carouselData.value.length > 0);

const ratePlanCount = computed<number>(
  () => (carouselData.value && carouselData.value.length) ?? 0,
);

const pagination = reactive({
  currentPage: 1,
  variableRateCurrentPage: 1,
  fixedRateCurrentPage: 1,
  perPage: 1,
  totalPages: computed<number>(() =>
    Math.ceil((carouselData.value || []).length / pagination.perPage),
  ),
  pages: computed<Array<number>>(() => [...Array(pagination.totalPages).keys()].map(i => i + 1)),
  currentRepaymentTerm: computed<number>(() => carouselData.value[0]?.repaymentTerm ?? 0),
}) as Pagination;

const currentlyViewing = computed(() => {
  if (rateTypeActive.value === 1) {
    return fixedRatePlans.value;
  } else if (rateTypeActive.value === 2) {
    return variableRatePlans.value;
  } else {
    return [];
  }
});

function setPosition(dataIndex: number) {
  if (dataIndex === carouselData.value?.length && carouselData.value?.length > 1) {
    return "left";
  } else if (dataIndex === 1) {
    return "center";
  } else if (dataIndex === 2) {
    return "right";
  } else {
    return "";
  }
}

function handlePaginationState() {
  if (rateTypeActive.value === RateTypeIds.FIXED) {
    pagination.fixedRateCurrentPage = pagination.currentPage;
  }

  if (rateTypeActive.value === RateTypeIds.VARIABLE) {
    pagination.variableRateCurrentPage = pagination.currentPage;
  }
}

async function setCurrentRateType(rateTypeId: number) {
  rateTypeActive.value = rateTypeId;

  if (rateTypeId === RateTypeIds.FIXED) {
    carouselData.value = fixedRatePlans.value;
  } else if (rateTypeId === RateTypeIds.VARIABLE) {
    carouselData.value = variableRatePlans.value;
  } else {
    carouselData.value = [];
  }
}

async function changePage(pageNumber: number) {
  const spliceSize = pageNumber - pagination.currentPage;
  const iterations = [...Array(Math.abs(spliceSize)).keys()].map(i => i + 1);

  if (pageNumber > pagination.currentPage) {
    iterations.forEach(() => {
      goNext();
    });
  }

  if (pageNumber < pagination.currentPage) {
    iterations.forEach(() => {
      goBack();
    });
  }
}

async function goNext() {
  if (pagination.currentPage >= pagination.totalPages) {
    // set current page to first item
    pagination.currentPage = 1;
  } else {
    pagination.currentPage++;
  }
  handlePaginationState();
  next();
}

async function goBack() {
  if (pagination.currentPage === 1) {
    // set current page to last item
    pagination.currentPage = pagination.pages[pagination.pages.length - 1];
  } else {
    pagination.currentPage--;
  }
  handlePaginationState();
  previous();
}

function previous() {
  if (validRatePlans.value) {
    // Update order of items in data array to be shown in carousel
    carouselData.value.unshift(carouselData.value.pop());
  }
}

function next() {
  if (validRatePlans.value) {
    // Update order of items in data array to be shown in carousel
    carouselData.value.push(carouselData.value.shift());
  }
}

async function saveChanges() {
  savingChanges.value = true;
  store.dispatch("loanConfigurationModule/setSavingChanges", true);

  if (!saveChangesDisabled.value) {
    await store.dispatch(
      "loanConfigurationModule/updateLoanConfiguration",
      editingFromConfirmYourLoanDetails.value,
    );
    emit("complete", true);
  } else {
    savingChanges.value = false;
    store.dispatch("loanConfigurationModule/setSavingChanges", false);
  }
}

async function getPreviouslySelectedRatePlan() {
  if (previouslySelectedRatePlan.value) {
    store.dispatch("loanConfigurationModule/setSelectedRatePlan", previouslySelectedRatePlan.value);

    await setCurrentRateType(previouslySelectedRatePlan.value.rateTypeId);

    let i = carouselData.value.findIndex(
      (rp: any) => rp.id === previouslySelectedRatePlan.value.id,
    );

    if (i > -1) {
      changePage(i + 1);
    }
    if (previouslySelectedRepaymentOption.value) {
      store.dispatch(
        "loanConfigurationModule/setSelectedRepaymentOption",
        previouslySelectedRepaymentOption.value,
      );
    }
  } else {
    setDefaultRateSection();
  }
}

function setDefaultRateSection() {
  if (rateTypeSections.value.length === 1) {
    rateTypeActive.value = rateTypeSections.value[0].rateTypeId;
    setCurrentRateType(rateTypeActive.value);
  } else {
    rateTypeActive.value = RateTypeIds.FIXED;
    carouselData.value = fixedRatePlans.value;
  }
}
function handleResize() {
  windowWidth.value = window.innerWidth;
}

async function getPelLoanOptions() {
  gettingData.value = true;

  await store.dispatch("loanConfigurationModule/getAvailableRatePlans");

  if (errorMessages.value?.length === 0) {
    await getPreviouslySelectedRatePlan();
  }

  windowWidth.value = window.innerWidth;

  gettingData.value = false;
}

onMounted(async () => {
  savingChanges.value = false;
  store.dispatch("loanConfigurationModule/setSavingChanges", false);

  window.addEventListener("resize", handleResize);
  await getPelLoanOptions();

  gettingData.value = false;
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", handleResize);
});

watch(
  () => rateTypeActive.value,
  (newValue, oldValue) => {
    if (oldValue > 0 && newValue > 0) {
      if (newValue === RateTypeIds.FIXED) {
        pagination.currentPage = pagination.fixedRateCurrentPage;
      }

      if (newValue === RateTypeIds.VARIABLE) {
        pagination.currentPage = pagination.variableRateCurrentPage;
      }
    }
  },
);

return (_ctx: any,_cache: any) => {
  return (__props.loading || gettingData.value)
    ? (_openBlock(), _createBlock(CircleLoader, { key: 0 }))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        _createElementVNode("div", _mergeProps({
          class: ["loan-options-wrapper", { dark: dark.value, mobile: isMobile.value, tablet: isTablet.value }]
        }, _ctx.$attrs), [
          _withDirectives(_createVNode(PelLoanOptionsHeader, {
            rateTypeActive: rateTypeActive.value,
            isMobile: isMobile.value,
            ratePlanCount: ratePlanCount.value,
            onSetCurrentRateType: setCurrentRateType
          }, null, 8, ["rateTypeActive", "isMobile", "ratePlanCount"]), [
            [_vShow, rateTypeActive.value > 0]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableTerms.value, (term, index) => {
              return (_openBlock(), _createElementBlock("button", {
                key: term,
                class: _normalizeClass({ active: pagination.currentRepaymentTerm === term }),
                onClick: _withModifiers(($event: any) => (changePage(Number(index) + 1)), ["prevent"])
              }, _toDisplayString(term) + " Year ", 11, _hoisted_2))
            }), 128))
          ], 512), [
            [_vShow, availableTerms.value.length > 0 && ratePlanCount.value > 1]
          ]),
          _createElementVNode("div", _hoisted_3, [
            (ratePlanCount.value > 1)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "loan-options-container-left",
                  onClick: goBack
                }, [...(_cache[1] || (_cache[1] = [
                  _createElementVNode("img", {
                    src: _imports_0,
                    alt: "left arrow icon"
                  }, null, -1)
                ]))]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", {
                class: "loan-options application-steps",
                "data-count": carouselData.value.length
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(carouselData.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.id,
                    class: "loan-option",
                    position: setPosition(index + 1)
                  }, [
                    (setPosition(index + 1) != '')
                      ? (_openBlock(), _createBlock(PelLoanOption, {
                          key: 0,
                          item: item,
                          position: setPosition(index + 1),
                          onGoBack: goBack,
                          onGoNext: goNext
                        }, null, 8, ["item", "position"]))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_6))
                }), 128))
              ], 8, _hoisted_5)
            ]),
            (ratePlanCount.value > 1)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "loan-options-container-right",
                  onClick: goNext
                }, [...(_cache[2] || (_cache[2] = [
                  _createElementVNode("img", {
                    src: _imports_1,
                    alt: "right arrow icon"
                  }, null, -1)
                ]))]))
              : _createCommentVNode("", true)
          ]),
          (ratePlanCount.value > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pagination.pages, (page) => {
                    return (_openBlock(), _createElementBlock("a", {
                      key: page,
                      class: _normalizeClass({ active: page === pagination?.currentPage })
                    }, null, 2))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ], 16),
        (error.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              (errorMessages.value.length <= 0)
                ? (_openBlock(), _createElementBlock("p", _hoisted_10, " Something has gone wrong submitting your request. If you continue to receive this error, please contact support. "))
                : (_openBlock(), _createElementBlock("ul", _hoisted_11, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(errorMessages.value, (error, index) => {
                      return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(error), 1))
                    }), 128))
                  ]))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: "loan-options-navigation-footer",
          "data-count": carouselData.value.length
        }, [
          (__props.showPreviousButton)
            ? (_openBlock(), _createBlock(NextButton, {
                key: 0,
                disabled: __props.loading || gettingData.value,
                text: "Previous",
                class: "cancel-btn",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('previous', true)))
              }, null, 8, ["disabled"]))
            : _createCommentVNode("", true),
          _createVNode(NextButton, {
            onClick: saveChanges,
            text: "Save Changes",
            class: "next-btn sc-next-button",
            disabled: saveChangesDisabled.value || __props.loading || gettingData.value || savingChanges.value,
            loading: savingChanges.value
          }, null, 8, ["disabled", "loading"])
        ], 8, _hoisted_12)
      ], 64))
}
}

})